export const UrlUtils = {

  obterUrlCompleta: caminhoRelativo => process.env.VUE_APP_JALEKO_BASE_URL + caminhoRelativo,
  obterUrlS3: caminhoRelativo => process.env.VUE_APP_BASE_FILES_URL + caminhoRelativo

}

export default UrlUtils
